import styled from 'styled-components';

import Button from '@components/web/src/atoms/Buttons/Button';
import { CloseButton } from '@components/web/src/atoms/Buttons/CloseButton/CloseButton';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Image } from '@components/web/src/foundations/Image/Image';
import { COLORS, GRADIENTS, RETAILER_COLORS } from '@components/web/src/styles';

export const ProductFeedbackResultPageContainer = styled(Flexbox)`
  flex: 1;
  background: ${COLORS.base.white};
`;

export const ProductContentWrapper = styled(Flexbox)`
  background: ${GRADIENTS.productGradient};
  border-radius: 0px 0px 16px 16px;
  padding-top: 16px;
`;

export const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: 2px solid #fff;
`;

export const CheckIcon = styled(Image)`
  height: 32px;
  width: 32px;
  min-height: 32px;
  min-width: 32px;
  margin-top: 20px;
`;

export const VisualAnalysisWrapper = styled(Flexbox)`
  background: ${RETAILER_COLORS.secondary['100']};
  border-radius: 8px;
`;

export const Divider = styled.div`
  border-bottom: 0.5px solid ${COLORS.base.black};
`;

export const CommentButton = styled(Button)`
  padding: 10px 12px;
  align-items: center;
  z-index: 99999;
`;
